import { inject, Injectable, Type } from '@angular/core';
import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { IFpLoggerNoiseTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-tab-connect-service';
import { FpLoggerNoiseLeakScoreMinimizedComponent } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-leak-score/components/fp-logger-noise-leak-score-minimized/fp-logger-noise-leak-score-minimized.component';
import { FpLoggerNoiseLeakScoreComponent } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-leak-score/components/fp-logger-noise-leak-score/fp-logger-noise-leak-score.component';
import { FpLoggerNoiseLeakScoreActionType } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-leak-score/services/fp-logger-noise-leak-score/fp-logger-noise-leak-score.actions';
import { FpLoggerNoiseLeakScoreStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-leak-score/services/fp-logger-noise-leak-score/fp-logger-noise-leak-score.store';
import { Observable } from 'rxjs';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

@Injectable()
export class FpLoggerNoiseLeakScoreConnectService implements IFpLoggerNoiseTabConnectService {
  protected tabStore = inject(FpLoggerNoiseLeakScoreStore);
  public currentTab = FpLoggerNoiseTabs.LeakScore;

  public component: Type<unknown> = FpLoggerNoiseLeakScoreComponent;
  public minimizedComponent: Type<unknown> = FpLoggerNoiseLeakScoreMinimizedComponent;

  public localLoading(): Observable<boolean> {
    return this.tabStore.loading$;
  }

  public isChartFullscreen(): Observable<boolean> {
    return this.tabStore.isChartFullscreenActive$;
  }

  public isActive(tab: FpLoggerNoiseTabs) {
    return this.currentTab === tab;
  }

  public initData(selectedDate: string, selectedData: ILdLogger) {
    this.tabStore.dispatch({
      type: FpLoggerNoiseLeakScoreActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }

  public updateData(selectedDate: string, selectedData: ILdLogger) {
    this.tabStore.dispatch({
      type: FpLoggerNoiseLeakScoreActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }
}
